import React from "react";
import {useMatch} from "react-router-dom";
function usePublicPage() {
    const isLoginTrue = useMatch("/usercenter/login/");
    const isLoginAuto = useMatch("/usercenter/autoLogin");
    const isHome = useMatch("/");
    const isNotfound = useMatch("/404");
    const isUpdatePassword = useMatch("/usercenter/updatePassword");

    function isPublicPage() {
        return isLogin() || isHome || isNotfound || isUpdatePassword
    }

    function isLogin() {
        return isLoginTrue || isLoginAuto
    }
    
    return {isPublicPage, isLogin, isHome, isNotfound, isUpdatePassword}
}

export default usePublicPage;
